import styled from 'styled-components';
import { Scroll } from '../../util/shared';
import { useContext, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import UserContext from '../../context/UserContext';


const Employees = () => {
const nav = useNavigate()

const {apiURL} = useContext(UserContext)

      const [searchQuery, setSearchQuery] = useState('');
  const path = window.location.pathname;

  const [customers, setCustomers] = useState([]);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });


  useEffect(() => {
    const getUsers = async () => {
      try {
        const res = await axios.post(`${apiURL}/users/getemps`);
       
       setCustomers(res.data.message);
      } catch (error) {
        console.error('Error fetching users:', error);
      }
    };

    getUsers();
  }, []);

const sortTable = (key) => {
    let direction = 'asc';
    if (sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc';
    }

    const sortedCustomers = [...customers].sort((a, b) => {
      if (a[key] < b[key]) return direction === 'asc' ? -1 : 1;
      if (a[key] > b[key]) return direction === 'asc' ? 1 : -1;
      return 0;
    });

    setCustomers(sortedCustomers);
    setSortConfig({ key, direction });
  };

  const getSortIndicator = (key) => {
    if (sortConfig.key === key) {
      return sortConfig.direction === 'asc' ? ' ↑' : ' ↓';
    }
    return '';
  };
 
const statustext = (item) => {
    let a
switch(item){
case '9':
    a = "Admin";
    break;
case '8':
    a = "Prepress";
    break;
case '7':
    a = "CSR";
    break;
    case '6':
    a = "Sales";
    break;
}
return a
}




  return (
<>
          <div className="flex w-full h-[10vh] mt-[60px] px-[10vw] justify-between items-center">
        <div className="flex-1 max-w-md text-left">
          <label className="block text-sm font-medium text-gray-700">Search</label>
          <input
            className="w-full bg-transparent placeholder:text-slate-400 text-slate-700 text-sm border border-slate-200 rounded-md px-3 py-2 transition duration-300 ease focus:outline-none focus:border-slate-400 hover:border-slate-300 shadow-sm focus:shadow"
            placeholder="Type here..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
        </div>
        {/* <div className="flex-1 text-right">
          <button
            type="button"
            className="text-white bg-gray-400 hover:bg-gray-500 font-medium rounded-lg text-sm px-5 py-2.5"
            onClick={path === '/dashboard/upload' ? () => nav('/dashboard') : () => nav('upload')}
          >
            {path === '/dashboard/upload' ? 'Go to Dashboard' : 'Upload File'}
          </button>
        </div> */}
      </div>
     <div className="p-4">
      
          <table className="w-full bg-white border border-gray-200">
            <thead className="bg-gray-100 sticky top-0">
              <tr className="flex w-full gap-3">
                
                <th
                  className="   flex-1  py-3 text-left text-base font-medium text-gray-500 uppercase tracking-wider cursor-pointer"
                
                >
                  User{getSortIndicator('name')}
                </th>
                <th
                  className="   flex-1  py-3 text-left text-base font-medium text-gray-500 uppercase tracking-wider cursor-pointer "
                
                >
                  Email{getSortIndicator('email')}
                </th>
                 <th
                  className="   flex-1  py-3 text-left text-base font-medium text-gray-500 uppercase tracking-wider cursor-pointer"
                 
                >
                  Access
                </th>
                 <th
                  className="   flex-1  py-3 text-left text-base font-medium text-gray-500 uppercase tracking-wider cursor-pointer"
                 
                >
                  Status
                </th>
                
                <th  className="  flex-1  py-3 text-left text-base font-medium text-gray-500 uppercase tracking-wider cursor-pointer">&nbsp;</th>
            
              </tr>
            </thead>
           
              <tbody className="min-w-full ">
                 <Scroll height="400px" width="100vw">
                {customers
                  .filter((customer) =>
                    customer.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
                    customer.email.toLowerCase().includes(searchQuery.toLowerCase())||
                    customer.company?.toLowerCase().includes(searchQuery.toLowerCase())
                  )
                  .map((customer) => (  
                    <tr key={customer._id} className="flex w-full hover:bg-gray-50 border-b-1 items-center gap-3" >
                     
                      <td className="  flex-1  py-3 text-left text-base font-medium text-gray-500 tracking-wider cursor-pointer">{customer.name}</td>
                      <td className="   flex-1  py-3 text-left text-base font-medium text-gray-500 tracking-wider cursor-pointer break-all">{customer.email}</td>
                           <td className="   flex-1  py-3 text-left text-base font-medium text-gray-500 tracking-wider cursor-pointer break-all">{customer.active === 'true' ? 'Active' : "Non Active"}</td>
                       <td className="  flex-1  py-3 text-left text-base font-medium text-gray-500 tracking-wider cursor-pointer">{statustext(customer.level)}</td>
                                <td className=" text-right flex-1  py-3 text-left text-base font-medium text-gray-500 tracking-wider cursor-pointer"><button className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-1 me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800" onClick={e => nav(`/dashboard/customer/${customer._id}`)}>Edit</button></td>
                     
                    </tr>
                  ))}
                    </Scroll>
              </tbody>
          
          </table>
        
      </div>
      </>
  )
}

export default Employees